module.exports = __webpack_public_path__ + "media/images/salespartner/merit01-b7393b41ef2a1d1ae91b7e56fbee44f5.svg";